<template>
  <div class="container">
    <el-descriptions
      title="设备端MQTT接入点"
      :column="1"
      border
      :labelStyle="{ width: '130px' }"
    >
      <el-descriptions-item label="MQTT主机"
        ><div class="txt" @click="copyInfo(mqtt.host)">
          {{ mqtt.host }} <i class="el-icon-copy-document"></i>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="端口"
        ><div class="txt" @click="copyInfo(mqtt.port)">
          {{ mqtt.port }}<i class="el-icon-copy-document"></i></div
      ></el-descriptions-item>
      <el-descriptions-item label="username"
        ><div class="txt" @click="copyInfo(mqtt.user)">
          {{ mqtt.user }}<i class="el-icon-copy-document"></i></div
      ></el-descriptions-item>
      <el-descriptions-item label="password"
        ><div class="txt" @click="copyInfo(mqtt.pd)">
          {{ mqtt.pd }}<i class="el-icon-copy-document"></i>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="clientID"
        ><div class="txt" @click="copyInfo(mqtt.clientID)">
          {{ mqtt.clientID }}<i class="el-icon-copy-document"></i>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="订阅主题"
        ><div class="txt" @click="copyInfo(mqtt.downTopic)">
          {{ mqtt.downTopic }}<i class="el-icon-copy-document"></i>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="推送主题"
        ><div class="txt" @click="copyInfo(mqtt.uploadTopic)">
          {{ mqtt.uploadTopic }}<i class="el-icon-copy-document"></i></div
      ></el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
import { copyText } from "@/utils/utils.js";
export default {
  props: {
    device: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      mqtt: {},
    };
  },

  mounted() {},
  methods: {
    copyInfo(v) {
      copyText(v);
    },
    init() {
      if (!this.mqtt.url) {
        this.getConn();
      }
    },
    getConn() {
      if (!this.device.device_code) {
        return;
      }
      let url = "/device/device/conn";
      let data = {
        device_id: this.device.device_id,
        device_code: this.device.device_code,
      };
      this.$post(url, data).then((res) => {
        this.mqtt = res.data.data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.txt{
    cursor: pointer;
}
</style>